import React, {useState} from 'react'
import {Box, Typography} from '@mui/material'
import {EnhancementOverviewTile} from './useEnhancementOverview'
import {cardStyles, titleStyles, totalCountStyles} from '../../../shared/UI/TrendIndicatorCard/TrendStyles'

interface EnhancementTileProps {
  tile: EnhancementOverviewTile;
  dataTestId?: string;
  isSelected?: boolean;
  onClick?: (requestType: string) => void;
}

function EnhancementTile({tile, dataTestId, isSelected = false, onClick}: EnhancementTileProps) {
  const [isHovered, setIsHovered] = useState(false)

  const handleMouseEnter = () => {
    setIsHovered(true)
  }

  const handleMouseLeave = () => {
    setIsHovered(false)
  }

  const handleClick = () => {
    if (onClick) {
      onClick(tile.name)
    }
  }

  const isClickable = !!onClick

  return (
    <Box
      sx={{
        ...cardStyles,
        cursor: isClickable ? 'pointer' : 'default',
        transform: isHovered && isClickable ? 'translateY(-3px)' : 'none',
        background: tile.color,
        padding: '12px 28px',
        ':not(:last-child)': {
          marginRight: '16px',
        },
        boxSizing: 'content-box',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        boxShadow: '0 3px 6px rgba(0, 0, 0, 0.18)',
        transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out, border 0.2s ease-in-out, opacity 0.2s ease-in-out',
        // Your desired selected state styling
        border: `3px solid ${isSelected ? tile.borderColor : 'transparent'}`,
        opacity: isSelected || !isClickable ? 1 : 0.9,
        '&:hover': isClickable ? {
          opacity: 1,
        } : {}
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick}
      data-testid={`${dataTestId}-${tile.name.replace(/\s+/g, '')}`}
    >
      <Typography
        sx={{
          ...titleStyles,
          color: '#000000',
          fontWeight: 600
        }}
        data-testid={`${dataTestId}-${tile.name.replace(/\s+/g, '')}-title`}
      >
        {tile.name}
      </Typography>
      <Box display="flex" alignItems="center" justifyContent="center">
        <Typography
          sx={{
            ...totalCountStyles,
            color: '#000000'
          }}
          data-testid={`${dataTestId}-${tile.name.replace(/\s+/g, '')}-hours`}
        >
          {tile.hours.toFixed(1)}
        </Typography>
        <Typography
          sx={{
            fontSize: '12px',
            color: tile.fontColor,
            fontWeight: 'regular',
            lineHeight: 1.2
          }}
        >
          hrs
        </Typography>
      </Box>
    </Box>
  )
}

export default EnhancementTile